'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Actions = require('common/domain/action/index');
const Dispatcher = require('common/domain/repository/dispatcher');
const Cacher = require('common/util/cacher');
const EventApi = require('notify/infra/api/event');

const Action = Backbone.Model.extend({
    initialize: function() {
        this._fetchedProjects = {};
        this._fetchedDiagrams = {};
    },

    fetchProjectEvents: function(projectId, options) {
        options = _.extend({}, options);
        const context = {projectId: projectId};
        return new Promise((resolve, reject) => {
            EventApi.getProjectEvents(projectId, {
                offset: options.offset, limit: options.limit})
                .then(events => {
                    Dispatcher.dispatch({
                        type: Actions.CREATE_EVENT,
                        context: context,
                        event: events,
                        options: {fetched: true}
                    });
                    resolve();
                }, reject);
        });
    },

    fetchProjectEventsOnce: Cacher(function() {
        return {
            store: this._fetchedProjects,
            func: this.fetchProjectEvents
        };
    }),

    fetchDiagramEvents: function(projectId, diagramId, options) {
        options = _.extend({}, options);
        const context = {projectId: projectId, diagramId: diagramId};
        return new Promise((resolve, reject) => {
            EventApi.getDiagramEvents(projectId, diagramId, {
                offset: options.offset, limit: options.limit})
                .then(events => {
                    Dispatcher.dispatch({
                        type: Actions.CREATE_EVENT,
                        context: context,
                        event: events,
                        options: {fetched: true}
                    });
                    resolve();
                }, reject);
        });
    },

    fetchDiagramEventsOnce: Cacher(function() {
        return {
            store: this._fetchedDiagrams,
            func: this.fetchDiagramEvents
        };
    })
});

module.exports = new Action();



// WEBPACK FOOTER //
// ./notify/domain/action/event.js